import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  ListReq,
  ListRes,
  DetailReq,
  DetailRes,
  ActionRes,
  UpdateReq,
  BestTrackingReq,
  LogsReq,
  LogsRes,
  NewOrderReq,
  NewOrderRes,
  BillReq,
  BillRes,
  TerminalStatusReq,
  TerminalStatusRes,
  UpdateOrderAddressReq,
  UpdateOrderAddressRes,
  UpdatePaymentTypeReq,
  UpdatePaymentTypeRes,
} from './types'

export const getListAction = createAsyncAction(
  'ORDER/GET_ORDER_LIST_REQ',
  'ORDER/GET_ORDER_LIST_SUCCESS',
  'ORDER/GET_ORDER_LIST_FAILURE',
)<ListReq, ListRes, Error>()

export const getDetailAction = createAsyncAction(
  'ORDER/GET_ORDER_DETAIL_REQ',
  'ORDER/GET_ORDER_DETAIL_SUCCESS',
  'ORDER/GET_ORDER_DETAIL_FAILURE',
)<DetailReq, DetailRes, Error>()

export const updateAction = createAsyncAction(
  'ORDER/UPDATE_ORDER_REQ',
  'ORDER/UPDATE_ORDER_SUCCESS',
  'ORDER/UPDATE_ORDER_FAILURE',
)<UpdateReq, ActionRes, any>()

export const createBestTrackingAction = createAsyncAction(
  'ORDER/CREATE_BEST_TRACKING_REQ',
  'ORDER/CREATE_BEST_TRACKING_SUCCESS',
  'ORDER/CREATE_BEST_TRACKING_FAILURE',
)<BestTrackingReq, ActionRes, Error>()

export const createBestTracking = createStandardAction('ORDER/CREATE_BEST_TRACKING')<{
  token: string
  xmid: string
  createTracking: BestTrackingReq
  updateStatus: UpdateReq
}>()

export const getOrderLogsAction = createAsyncAction(
  'ORDER/GET_ORDER_LOGS_REQ',
  'ORDER/GET_ORDER_LOGS_SUCCESS',
  'ORDER/GET_ORDER_LOGS_FAILURE',
)<LogsReq, LogsRes, Error>()

export const countNewOderAction = createAsyncAction(
  'ORDER/COUNT_NEW_ORDER_REQ',
  'ORDER/COUNT_NEW_ORDER_SUCCESS',
  'ORDER/COUNT_NEW_ORDER_FAILURE',
)<NewOrderReq, NewOrderRes, Error>()

export const getPosBillAction = createAsyncAction(
  'ORDER/GET_POS_BILL_REQ',
  'ORDER/GET_POS_BILL_SUCCESS',
  'ORDER/GET_POS_BILL_FAILURE',
)<BillReq, BillRes, Error>()

export const updateTerminallStatusAutoAction = createAsyncAction(
  'ORDER/UPDATE_TERMINAL_STATUS_REQ',
  'ORDER/UPDATE_TERMINAL_STATUS_SUCCESS',
  'ORDER/UPDATE_TERMINAL_STATUS_FAILURE',
)<TerminalStatusReq, TerminalStatusRes, Error>()

export const updateOrderAddressAction = createAsyncAction(
  'ORDER/UPDATE_ORDER_ADDRESS_REQ',
  'ORDER/UPDATE_ORDER_ADDRESS_SUCCESS',
  'ORDER/UPDATE_ORDER_ADDRESS_FAILURE',
)<UpdateOrderAddressReq, UpdateOrderAddressRes, Error>()

export const updatePaymentTypAction = createAsyncAction(
  'ORDER/UPDATE_PAYEMNT_TYPE_REQ',
  'ORDER/UPDATE_PAYEMNT_TYPE_SUCCESS',
  'ORDER/UPDATE_PAYEMNT_TYPE_FAILURE',
)<UpdatePaymentTypeReq, UpdatePaymentTypeRes, Error>()

export const clearEventAction = createStandardAction('ORDER/CLEAR_EVENT')<void>()
